const STORAGE_KEY = 'fastcut.device-installation-id.v1'
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

/** 浏览器本地随机安装标识；不包含硬件、屏幕或 Canvas 指纹信息。 */
export function getDeviceInstallationId() {
  if (typeof window === 'undefined' || !window.localStorage || !window.crypto?.randomUUID) return null

  try {
    const existing = window.localStorage.getItem(STORAGE_KEY)
    if (existing && UUID_PATTERN.test(existing)) return existing

    const created = window.crypto.randomUUID()
    window.localStorage.setItem(STORAGE_KEY, created)
    return created
  } catch {
    return null
  }
}
